export default __webpack_public_path__ + "static/media/css.937e1354.png";